import { HISTORY_BINANCE_COLUMNS_TO_OMIT } from '@/core/config/history'
import { getBinanceIncomeTypes } from '@/pages/History/components/HistoryTrade/HistoryTrade.translations/binanceHistoryDictionary'
import { ExchangeHistoryItemInterface } from '@/redux/transactions/transactions.types'
import {
  convertAllValuesToString,
  dateFormatter,
  tryNumberFormatter,
} from '@/ui/organisms/HistoryTrade/HistoryTrade.utils/utils'
import { TUsdmIncomeHistory } from '@tigertrade/binance-ts'
import { AccountBill } from 'okx-api'

export const normalizeBalance = (value: number | string, decimals = 8): string => {
  if (value === null || value === undefined) return '0'

  const num = typeof value === 'string' ? Number(value) : value
  if (isNaN(num) || !isFinite(num)) return '0'

  const factor = Math.pow(10, decimals)
  const truncated = Math.floor(num * factor) / factor

  return truncated.toFixed(decimals)
}

const binanceHistoryFormattres: Partial<Record<keyof TUsdmIncomeHistory, Function>> = {
  time: (source: string) => dateFormatter(source),
  incomeType: (source: string) => getBinanceIncomeTypes()[source] || source,
}

export const binanceHistoryToHistoryItem = (source: TUsdmIncomeHistory): ExchangeHistoryItemInterface => {
  const cloned: Record<string, string> = { ...convertAllValuesToString(source) }

  Object.entries(cloned).forEach(([key, value]) => {
    if (value === undefined || value === '') {
      delete cloned[key as keyof AccountBill]
    }
  })

  return Object.keys(cloned).reduce((acc, key) => {
    if (HISTORY_BINANCE_COLUMNS_TO_OMIT.includes(key as keyof TUsdmIncomeHistory)) return acc
    const formatter = binanceHistoryFormattres[key as keyof TUsdmIncomeHistory]
    return {
      ...acc,
      ...(formatter ? { [key]: formatter(cloned[key]) } : { [key]: tryNumberFormatter(cloned[key]) }),
    }
  }, {})
}
